import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import Book from "@/pages/Book";

export const Route = createFileRoute("/_public/book")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Book a Free Virtual Consultation | Modern Fence Install", "Schedule your free virtual consultation for non-electric dog, deer, or garden fence installation. Expert recommendations and a transparent, itemized written quote.", "/book", false),
  component: Book,
});
